/**
 * Wraps the chassis anomaly detector with Hisaab Transaction shape.
 */
import { detectAnomalies, detectWeeklyDrift, type AnomalyPoint, type AnomalyResult } from '../chassis/anomaly.ts';
import type { Summary, Transaction } from '../types.ts';
import { CATEGORY_DISPLAY } from '../types.ts';

function toPoint(t: Transaction): AnomalyPoint {
  return { category: t.category, amount: t.amount_inr, date: t.date };
}

export function scanForAnomaly(summary: Summary, tx: Transaction): AnomalyResult | null {
  return detectAnomalies(summary.transactions.map(toPoint), toPoint(tx), 90);
}

export interface DriftNudge {
  readonly category: string;
  readonly humanCategory: string;
  readonly thisWeek: number;
  readonly baseline: number;
  readonly pct: number;
  readonly verdict: 'rising' | 'falling';
}

export function weeklyDrift(summary: Summary): DriftNudge[] {
  const raw = detectWeeklyDrift(summary.transactions.map(toPoint));
  return raw.map((r) => ({
    category: r.category,
    humanCategory: CATEGORY_DISPLAY[r.category as keyof typeof CATEGORY_DISPLAY] ?? r.category,
    thisWeek: r.thisWeek,
    baseline: r.baseline,
    pct: r.pct,
    verdict: r.pct >= 0 ? 'rising' : 'falling',
  }));
}
